import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { List } from '@material-ui/core';
import Alert from './Alert';
import BookForm from './BookForm';
import BookListItem from './BookListItem';
import { deleteBook } from '../redux/actions';
import { Book, BookTemplate, ReduxState } from '../types';


const useStyles = makeStyles(({
  root: {
    width: '50%',
    minWidth: '300px',
    height: '75vh',
    maxHeight: '500px',
    overflow: 'auto',
  }
}));

function isBook(tbd: Book | BookTemplate): tbd is Book {
  if ((tbd as Book)._links) {
      return true;
  }
  return false;
}

const EMPTY_BOOK_TEMPLATE: BookTemplate = {
  title: '',
  authors: '',
  status: 'backlog',
};


const BookList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const books: Book[] = useSelector((state: ReduxState) => state.books);
  
  const [selectedBook, setSelectedBook] = React.useState<Book | BookTemplate>(EMPTY_BOOK_TEMPLATE);
  const [bookFormIsOpen, toggleBookForm] = React.useState<boolean>(false);
  const [alertIsOpen, toggleAlert] = React.useState<boolean>(false);

  const handleEditBook = (book: Book) => {
    setSelectedBook(book);
    toggleBookForm(!bookFormIsOpen);
  }

  const handleDeleteBook = (book: Book) => {
    setSelectedBook(book);
    toggleAlert(!alertIsOpen);
  }

  const confirmDeleteBook = () => {
    if (isBook(selectedBook)) {
      dispatch(deleteBook(selectedBook));
      toggleAlert(!alertIsOpen);
    }
  }

  const handleToggleBookForm = () => {
    toggleBookForm(!bookFormIsOpen);
  }

  const handleToggleAlert = () => {
    toggleAlert(!alertIsOpen);
  }

  const bookListItemProps = {
    openBookForm: handleEditBook,
    openAlert: handleDeleteBook,
  }

  const bookFormProps = {
    defaultValues: selectedBook,
    isOpen: bookFormIsOpen,
    closeForm: handleToggleBookForm,
  };
  
  return (
    <div className={classes.root}>
      <List>
          {
              books.map((book, index) => (
                  <BookListItem key={index} {...bookListItemProps} {... {book: book}} />
              ))
          }
      </List>
      <BookForm { ...bookFormProps } />
      <Alert
        cancel={handleToggleAlert}
        confirm={confirmDeleteBook}
        isOpen={alertIsOpen}
        message="This action cannot be undone."
        title={`Remove "${selectedBook.title}"?`}
      />
    </div>
  );
}

export default BookList;